// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"01b2deb2","273":"bef9f44e","415":"6226af47","493":"adf5291a","775":"b59de31d"}[chunkId] + ".chunk.js";
};